import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import {AppSettings} from '../../app.constant';
import {Sponser} from '../interface/sponser';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SponserService {
  httpOptions:any;
  headers:any;

private _refreshNeeded$ = new Subject<void>();

get refreshNeeded$() {
    return this._refreshNeeded$;
  }
  
constructor(private http:HttpClient) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
    })
  }
}
 
getAllSponsers(url){
    return this.http.get(url,this.httpOptions)
  }

getSponserByID(url,param){
    //return this.http.get(url,this.httpOptions)
    return this.http.post<Sponser>(url,param,this.httpOptions)
  }

postSponser(url,param){
    return this.http.post<Sponser>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
  
updateSponser(url,param){
    return this.http.put<Sponser>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }

deleteSponserByID(url,param){
    return this.http.put<Sponser>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
}
